import { NotificationMessages } from '../types';

const NOTIFICATION_LS_KEY = 'notification_messages';

const readNotificationsFromLS = (): NotificationMessages => {
  try {
    const raw = localStorage.getItem(NOTIFICATION_LS_KEY);
    if (!raw) return [];
    const parsed = JSON.parse(raw);
    return Array.isArray(parsed) ? parsed : [];
  } catch {
    localStorage.removeItem(NOTIFICATION_LS_KEY);
    return [];
  }
};

const mergeNotifications = (
  primary: NotificationMessages | null,
  fallback: NotificationMessages | null,
): NotificationMessages => {
  const result: NotificationMessages = [];
  const seen = new Set<number>();

  (primary || []).forEach((item) => {
    if (!seen.has(item.notification_id)) {
      seen.add(item.notification_id);
      result.push(item);
    }
  });

  (fallback || []).forEach((item) => {
    if (!seen.has(item.notification_id)) {
      seen.add(item.notification_id);
      result.push(item);
    }
  });

  return result;
};

export const saveNotificationsToLS = (
  incoming: NotificationMessages | null,
): NotificationMessages => {
  const existing = readNotificationsFromLS();
  const merged = mergeNotifications(incoming, existing);
  localStorage.setItem(NOTIFICATION_LS_KEY, JSON.stringify(merged));
  return merged;
};
